import { graphql } from "gatsby"
import {
  useStoryblokState,
  storyblokEditable,
  SbGatsbyStory,
} from "gatsby-source-storyblok"
import React from "react"

import SEO from "../components/SEO"
import Page from "../components/StoryBlok/Page"

type Props = {
  location: any
  data: {
    story: SbGatsbyStory & Storyblok.Page
  }
}

export const Head = ({ data, location }: Props): React.ReactElement => {
  return (
    <>
      <SEO
        path={location.pathname}
        meta={{
          image: data.story.content.meta_image?.filename,
          title: data.story.content.meta_title,
          description: data.story.content.meta_description,
          ogTitle: data.story.content.og_title,
          ogDescription: data.story.content.og_description,
          twitterTitle: data.story.content.twitter_title,
          twitterDescription: data.story.content.twitter_description,
          structuredData: data.story.content.structured_data,
        }}
        noIndex={data.story.content.noIndex}
      />
    </>
  )
}

export const PageTemplate = ({ data }: Props) => {
  const story = useStoryblokState(data.story, {
    resolveRelations: process.env.GATSBY_STORYBLOK_RESOLVE_RELATIONS,
  })

  return (
    <div {...storyblokEditable(story.content)}>
      <Page blok={story.content as Storyblok.PageContent} />
    </div>
  )
}

export const query = graphql`
  query page($uuid: String) {
    story: storyblokEntry(uuid: { eq: $uuid }) {
      name
      content
      full_slug
      uuid
      id
      internalId
      field_meta_title_string
      field_meta_description_string
      field_og_title_string
      field_og_description_string
      field_twitter_title_string
      field_twitter_description_string
      field_structured_data_string
    }
  }
`

export default PageTemplate
